// src/utils/pdfWorker.js
// The one place the pdf.js worker URL is chosen (FirebaseMarker and
// ExamMaterialPanel both use it). Must match the pdfjs-dist version react-pdf
// ships with. Loaded from unpkg, not cdnjs (see CLAUDE.md).
//
// Older browsers (no Promise.withResolvers - see src/polyfills.js) get
// pdf.js's legacy worker build, which carries its own polyfills; everyone
// else gets exactly the same modern worker as before.

import { NEEDS_LEGACY_PDF_WORKER } from '../polyfills';

const PDFJS_VERSION = '4.4.168';

export const PDF_WORKER_SRC = NEEDS_LEGACY_PDF_WORKER
  ? `https://unpkg.com/pdfjs-dist@${PDFJS_VERSION}/legacy/build/pdf.worker.min.mjs`
  : `https://unpkg.com/pdfjs-dist@${PDFJS_VERSION}/build/pdf.worker.min.mjs`;
